var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { Children } from 'react';
import { AccordionGroupProvider } from '../context';
import { AccordionTestIdFactory } from '../interactions';
import styles from './AccordionGroup.module.css';
export const AccordionGroup = ({ children, 'data-testid': testid, expandMode, ...rest }) => {
    const group = (_jsx("ul", { className: styles.Container, "data-testid": AccordionTestIdFactory.getAccordionGroupTestId(testid), children: Children.map(children, (acc) => {
            return _jsx("li", { children: acc }, acc.props.id);
        }) }));
    if (expandMode === 'single' || expandMode === 'single-collapsible') {
        return (_jsx(AccordionGroupProvider, { allowCollapse: expandMode === 'single-collapsible', ...rest, children: group }));
    }
    return group;
};
_react_refresh_temp_1 = AccordionGroup;
$RefreshReg$(_react_refresh_temp_1, "AccordionGroup");
